import React from 'react';

import PrintMenu from './PrintMenu';
import EmailMenu from './EmailMenu';
import LinkMenu from './LinkMenu';
import SlackMenu from './SlackMenu';
import { canCreateSharableLink } from '../../utilities/permissionsUtilities';
import EmailVerificationGuard from '../EmailVerificationGuard';
import { sanitizeHTML, decodeHtmlEntities } from '../../utilities/sanitizeHTML';

const DEFAULT_STATE = {
    menu: 'Slack',
};

const EMAIL_STATE = {
    menu: 'Email',
};

const LINK_STATE = {
    menu: 'Link',
};

const PAGE_MENU_ITEMS = {
    Link: {
        name: 'Link',
        icon: 'link',
        submenu: LinkMenu,
    },
    Print: {
        name: 'Print',
        icon: 'print',
        submenu: PrintMenu,
    },
};

const PRINT_MENU_ITEM = {
    Print: {
        name: 'Print',
        icon: 'print',
        submenu: PrintMenu,
    },
};

const BASE_MENU_ITEMS = {
    Email: {
        name: 'Email',
        icon: 'email',
        submenu: EmailMenu,
    },
};

const SLACK_MENU_ITEM = {
    Slack: {
        name: 'Slack',
        icon: 'slack',
        submenu: SlackMenu,
    },
};

const FIRST_SHARE_MESSAGE = '👏 Nice work! You\'re well on your way to organizing and sharing your team\'s collective knowledge. Share this page to get your teammates involved.';

class ShareModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getState(props);
        this.MENU_ITEMS = BASE_MENU_ITEMS;

        if (window.hasSlack) {
            this.MENU_ITEMS = Object.assign(this.MENU_ITEMS, SLACK_MENU_ITEM);
        }
        if (window.pageId && window.adminAllowsPageAuthorizations) {
            this.MENU_ITEMS = Object.assign(this.MENU_ITEMS, PAGE_MENU_ITEMS);
        }
        if (window.pageId && !window.adminAllowsPageAuthorizations) {
            if (this.props.page && this.props.page.authorizationLink) {
                this.MENU_ITEMS = Object.assign(this.MENU_ITEMS, PAGE_MENU_ITEMS);
            } else {
                this.MENU_ITEMS = Object.assign(this.MENU_ITEMS, PRINT_MENU_ITEM);
            }
        }
    }

    getState = (props) => {
        const state = !window.teamOnFreeTier ? LINK_STATE : ((window.hasSlack) ? DEFAULT_STATE : EMAIL_STATE);
        state.menu = props.menu || state.menu;
        return state;
    };

    setMenuItem = (item) => {
        const { menu } = this.state;
        if (menu !== item) {
            this.setState({ menu: item, errorMessage: '' });
        }
    };

    setNotification = (notificationMessage) => {
        this.setState({ notificationMessage });
    };

    setErrorMessage = (errorMessage) => {
        this.setState({ errorMessage });
    };

    onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (this.props.closeModal && className && className.includes('react-modal open')) {
            this.props.closeModal();
        }
    };

    render() {
        const { menu, notificationMessage, errorMessage } = this.state;
        const { page, isFirstShare } = this.props;
        const menuItem = this.MENU_ITEMS[menu] || null;
        const Submenu = menuItem.submenu;
        const rawTitle = page.title;

        page.title = sanitizeHTML(page.title); // sanitize the title before sharing, to prevent JS injection

        return (
            <div className="react-modal open share-page-modal" onMouseDown={this.onClickModal}>
                <div className="modal-content">
                    <EmailVerificationGuard sectionTitle="Share page" closeModal={this.props.closeModal}>
                        {(isFirstShare || notificationMessage)
                            && (
                                <div className="share-notification mxn2 myn2 rounded-top">
                                    {notificationMessage || FIRST_SHARE_MESSAGE}
                                </div>
                            )}
                        {(errorMessage)
                            && (
                                <div className="share-error mxn2 myn2 rounded-top">
                                    {errorMessage}
                                </div>
                            )}
                        <h2>Share page</h2>
                        <div className="mt2 mb2 flex">
                            <img className="flex-none mr1" height="22" src="/img/icons/file-icon-page.png" alt="" />
                            <div className="flex-auto">
                                <span className="h4">{decodeHtmlEntities(rawTitle)}</span>
                            </div>
                        </div>
                        <ShareMenu menu={menu} setMenuItem={this.setMenuItem} MENU_ITEMS={this.MENU_ITEMS} />
                        <Submenu page={page} setNotification={this.setNotification} setErrorMessage={this.setErrorMessage} closeModal={this.props.closeModal} />
                    </EmailVerificationGuard>
                </div>
            </div>
        );
    }
}

class ShareMenu extends React.Component {
    render() {
        const { menu, MENU_ITEMS } = this.props;
        if ('Link' in MENU_ITEMS && !canCreateSharableLink) {
            delete MENU_ITEMS.Link;
        }
        const menuItems = Object.keys(MENU_ITEMS).map(key => {
            const item = MENU_ITEMS[key];
            return (
                <ShareMenuIcon
                    key={item.name}
                    item={item}
                    active={item.name === menu}
                    setMenuItem={this.props.setMenuItem}
                />
            );
        });
        return (
            <div>
                <h4>Share via</h4>
                <div className="flex">
                    {menuItems}
                </div>
            </div>
        );
    }
}

const ShareMenuIcon = (props) => {
    const { name, icon, iconActive } = props.item;
    const active = props.active ? 'active' : '';
    const src = props.active ? `${icon}-active` : icon;
    return (
        <div className={`share-menu-icon flex-auto ${active}`} onMouseDown={() => props.setMenuItem(name)}>
            {name}
            <img className="flex-none" width="22" src={`/img/icons/share/${src}.png`} />
        </div>
    );
};

export default ShareModal;
